import { render, staticRenderFns } from "./DynamicCommenList.vue?vue&type=template&id=0f610443&scoped=true"
import script from "./DynamicCommenList.vue?vue&type=script&lang=js"
export * from "./DynamicCommenList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f610443",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f610443')) {
      api.createRecord('0f610443', component.options)
    } else {
      api.reload('0f610443', component.options)
    }
    module.hot.accept("./DynamicCommenList.vue?vue&type=template&id=0f610443&scoped=true", function () {
      api.rerender('0f610443', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/circle/dynamic/DynamicCommenList.vue"
export default component.exports